import { ListResponse, PaginationRequest } from './client/types'
import { useAPI } from './client/useAPI'

export type EventListItem = {
  id: string
  type: string
  input: object
  referenceId: string
  referenceType: string
  createdAt: string
  updatedAt: string
  admin: {
    id: string
    email: string
  }
}

export type EventsRequest = PaginationRequest & {
  referenceId?: string[]
  referenceType?: string
  eventType?: string
  createdAtFrom?: string
  createdAtTo?: string
  adminId?: string
}

type EventsResponse = ListResponse<EventListItem>

export const useEvents = () => {
  return useAPI<EventsResponse, EventsRequest>('GET', '/events', {
    withToken: true,
  })
}
